import { render, staticRenderFns } from "./Index_Mobile.vue?vue&type=template&id=a8ddb04e&scoped=true&"
import script from "./Index_Mobile.vue?vue&type=script&lang=js&"
export * from "./Index_Mobile.vue?vue&type=script&lang=js&"
import style0 from "./Index_Mobile.vue?vue&type=style&index=0&id=a8ddb04e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ddb04e",
  null
  
)

export default component.exports